import gsap from 'gsap';


export default class Character{

    constructor(){
        this._init();
    }

    
    _init(){
        this.$self = document.querySelector('.c-chara');
        this.$ba = document.querySelector('.c-chara__ba');
        this.isShopVisible = false;
        this.isRun = false;

        document.addEventListener('scroll', ()=>{
            this._onScroll();
        });

        this._isPageShopBtnVisible();
    }


    _onScroll(){
        const vect = this.$self.getAttribute('data-vect');

        if(!this.isRun){
            this.$self.setAttribute('data-action', 'run');
            this.$self.classList.remove('-shoplink');
            this.$ba.classList.remove('-active');
            this.isRun = true;
        }
        
        if(vect === 'left'){
            gsap.set(this.$self, {right:'+=3'});

            const leMax = window.innerWidth - this.$self.getBoundingClientRect().width;
            if(parseInt(this.$self.style.right) >= leMax){
                this.$self.setAttribute('data-vect', 'right');
            }
        }
        else{
            gsap.set(this.$self, {right: '-=2'});

            if(parseInt(this.$self.style.right) <= 0){
                this.$self.setAttribute('data-vect', 'left');
            }
        }
        
        clearTimeout(this.timeId);
        this.timeId = setTimeout(()=>{
            this.$ba.classList.remove('-ba2');
            this.$self.classList.remove('-shoplink');

            if(!this.isShopVisible){
                const rect = this.$self.getBoundingClientRect();
                if(rect.left < 100) this.$ba.classList.add('-ba2');
                this.$self.classList.add('-shoplink');
            }
            
            this.$self.setAttribute('data-action', 'stay');
            this.isRun = false;
        }, 150);
    }


    /**
     * ショップエリアが見えているか
     */
    _isPageShopBtnVisible(){
        const $shop = document.querySelector('.shop');
        if(!$shop){
            this.isShopVisible = false;
            return;
        }

        const observer = new IntersectionObserver(entries => {
            if(entries[0].isIntersecting) this.isShopVisible = true;
            else this.isShopVisible = false;
        }); 
        observer.observe($shop);
    }
}
